import React from 'react';
import ReactDOM from 'react-dom';

import './Style.css';

class ValidarEmpreendimento extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            sending: false,
            cityPeriod: props.cityPeriod || null,
            empreendimentos: [],
            errors: {},
        };
    }

    fetchEvaluations = async () => {
        const {
            cityPeriod,
        } = this.state;

        if (!cityPeriod?.id) {
            return;
        }

        this.setState({
            loading: true,
        });

        try {
            const response = await axios.get(`/listar-avaliacoes/${cityPeriod.id}`);

            this.setState({
                empreendimentos: response.data?.data || [],
                loading: false
            });

        } catch (error) {
            console.error('Erro ao buscar lista de avaliações:', error);

            this.setState({
                loading: false,
            });
        }
    };

    componentDidMount() {
        this.fetchEvaluations();
    }

    getEvaluationGroups = (empreendimento) => {
        const groups = {};

        (empreendimento.evaluations || []).forEach(
            (evaluation) => {
                const evaluationWeight = evaluation.evaluation_weigth;

                if (!evaluationWeight) {
                    return;
                }

                const weightId = evaluationWeight.id;

                if (!groups[weightId]) {
                    groups[weightId] = {
                        evaluationWeight,
                        evaluations: [],
                        conditionals: [],
                    };
                }

                groups[weightId].evaluations.push(
                    evaluation
                );

                if (evaluation.conditional) {
                    groups[weightId].conditionals.push({
                        ...evaluation.conditional,
                        evaluationId: evaluation.id,
                    });
                }
            }
        );

        return Object.values(groups);
    };

    formatConditional = (conditional) => {
        if (!conditional) {
            return '';
        }

        const {
            operator,
            compare_with,
            fixed_value,
            field,
        } = conditional;

        const parts = [];

        if (operator) {
            parts.push(operator);
        }

        if (compare_with) {
            parts.push(compare_with);
        }

        if (fixed_value !== null && fixed_value !== undefined && fixed_value !== '') {
            parts.push(`"${fixed_value}"`);
        }

        if (field) {
            parts.push(`campo: ${field}`);
        }

        return parts.join(' ');
    };

    /**
     * Remove a inconsistência da linha.
     */
    handleRemoveInconsistencia = (
        empreendimentoId,
        evaluationId
    ) => {
        this.setState((previousState) => {
            const empreendimentos =
                previousState.empreendimentos.map((empreendimento) => {
                        if (empreendimento.id !== empreendimentoId) {
                            return empreendimento;
                        }

                        return {
                            ...empreendimento,

                            evaluations:
                                (empreendimento.evaluations || [])
                                    .filter(
                                        (evaluation) =>
                                            evaluation.id !==
                                            evaluationId
                                    ),
                        };
                    })
                    .filter(
                        (empreendimento) =>
                            empreendimento.evaluations &&
                            empreendimento.evaluations.length > 0
                    );

            return {
                empreendimentos,
            };
        });
    };

    handleRemoveConditional = (
        empreendimentoId,
        evaluationId
    ) => {

        this.setState((previousState) => {

            const empreendimentos =
                previousState.empreendimentos
                    .map((empreendimento) => {
                        if (empreendimento.id !== empreendimentoId) {
                            return empreendimento;
                        }

                        return {
                            ...empreendimento,

                            evaluations:
                                (empreendimento.evaluations || [])
                                    .filter(
                                        (evaluation) =>
                                            evaluation.id !==
                                            evaluationId
                                    ),
                        };
                    })
                    .filter(
                        (empreendimento) =>
                            empreendimento.evaluations &&
                            empreendimento.evaluations.length > 0
                    );
            return {
                empreendimentos,
            };
        });
    };

    /**
     * Remove o critério/regra da linha.
     */
    handleRemoveCriterio = (
        empreendimentoId,
        evaluationWeightId,
    ) => {
        this.setState((previousState) => {
            const empreendimentos =
                previousState.empreendimentos.map((empreendimento) => {
                        if (empreendimento.id !== empreendimentoId) {
                            return empreendimento;
                        }

                        return {
                            ...empreendimento,

                            evaluations:
                                (empreendimento.evaluations || [])
                                    .filter(
                                        (evaluation) =>
                                            evaluation
                                                .evaluation_weigth
                                                ?.id !==
                                            evaluationWeightId
                                    ),
                        };
                    })
                    .filter(
                        (empreendimento) =>
                            empreendimento.evaluations &&
                            empreendimento.evaluations.length > 0
                    );

            return {
                empreendimentos,
            };
        });
    };

    handleComentarioChange = (empreendimentoId, comentario) => {
        this.setState((previousState) => ({
            empreendimentos: previousState.empreendimentos.map(
                (empreendimento) => {
                    if (empreendimento.id !== empreendimentoId) {
                        return empreendimento;
                    }

                    return {
                        ...empreendimento,
                        comentario,
                    };
                }
            ),
        }));
    };

    /**
     * Executa a avaliação e remove a linha.
     */
    handleAvaliar = async (empreendimento) => {
        try {
            this.setState({
                sending: true
            });

            const evaluationGroups = this.getEvaluationGroups(empreendimento);

            await axios.post(
                `/avaliar/${empreendimento.id}`,
                {
                    comentario: empreendimento.comentario || null,
                    motivos: evaluationGroups.flatMap(
                        (group) =>
                            group.evaluations.map((evaluation) => ({
                                evaluation_id: evaluation.id,
                                evaluation_weight_id: evaluation.evaluation_weigth?.id,
                                evaluation_rule_id: evaluation.evaluation_rule?.id,
                                conditional_id: evaluation.conditional?.id,
                            }))
                    )
                }
            );

            alert('Avaliação realizada com sucesso');

            this.setState((previousState) => {
                return {
                    empreendimentos: previousState.empreendimentos.filter(
                        (item) => item.id !== empreendimento.id
                    ),
                    sending: false,
                };
            });
        } catch (error) {
            console.error('Erro ao avaliar empreendimento:', error);

            this.setState({
                sending: false,
            });
        }
    };

    /**
     * Verifica se a avaliação ainda possui condições suficientes para exibir o botão Avaliar.
     */
    canAvaliar = (empreendimento) => {
        return (
            empreendimento.evaluations &&
            empreendimento.evaluations.length > 0
        );
    };

    render() {
        const {
            empreendimentos,
            cityPeriod,
            loading,
            sending,
        } = this.state;

        return (
            <div>
                <div className="lista-empreendimentos">
                    <div className="card" style={{ height: '100%' }}>
                        {loading ? (
                            <div className="text-center">
                                <i className="fa fa-spinner fa-spin"></i>
                            </div>
                        ) : empreendimentos.length === 0 ? (
                            <p className="title">Nenhuma avaliação encontrada.</p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table-stripped">
                                    <thead>
                                        <tr>
                                            <th>Empreendimento</th>
                                            <th>Inconsistência</th>
                                            <th>Critério sugerido</th>
                                            <th>Erro</th>
                                            <th>Comentário</th>
                                            <th style={{ textAlign: 'center' }}>Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {empreendimentos.map(
                                            (empreendimento) => {
                                                const evaluationGroups = this.getEvaluationGroups(empreendimento);
                                                const podeAvaliar = this.canAvaliar(empreendimento);

                                                return (
                                                    <tr key={ empreendimento.id }>
                                                        <td>
                                                            <a
                                                                href={`/building/${empreendimento.building_id}`}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                <strong>{ empreendimento.building_name }</strong>
                                                            </a>
                                                        </td>

                                                        <td>
                                                            <div className="botoes-inconsistencia">
                                                                {evaluationGroups.map(
                                                                    (group) => (
                                                                        <React.Fragment
                                                                            key={group.evaluationWeight.id}
                                                                        >
                                                                            {group.conditionals.map(
                                                                                (
                                                                                    conditional
                                                                                ) => (

                                                                                    <button
                                                                                        key={
                                                                                            conditional.id
                                                                                        }
                                                                                        type="button"
                                                                                        className="btn btn-inconsistencia"
                                                                                    >

                                                                                        {this.formatConditional(conditional)}
                                                                                        {' '}
                                                                                        <span
                                                                                            className="p-multiselect-token-icon pi pi-times-circle"
                                                                                            onClick={() =>
                                                                                                this.handleRemoveConditional(
                                                                                                    empreendimento.id,
                                                                                                    conditional.evaluationId
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                        </span>

                                                                                    </button>

                                                                                )
                                                                            )}
                                                                        </React.Fragment>
                                                                    )
                                                                )}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="botoes-inconsistencia">
                                                                {evaluationGroups.map(
                                                                    (group) => (
                                                                        <button
                                                                            key={group.evaluationWeight.id}
                                                                            type="button"
                                                                            className="btn btn-inconsistencia"
                                                                        >
                                                                            {group.evaluationWeight.criterion}
                                                                            {' '}
                                                                            <span
                                                                                className="p-multiselect-token-icon pi pi-times-circle"
                                                                                onClick={() =>
                                                                                    this.handleRemoveCriterio(
                                                                                        empreendimento.id,
                                                                                        group.evaluationWeight.id
                                                                                    )
                                                                                }
                                                                            >
                                                                            </span>
                                                                        </button>
                                                                    )
                                                                )}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <div className="erros-empreendimento">
                                                                {evaluationGroups.map(
                                                                    (group) => (
                                                                        <div key={group.evaluationWeight.id}>
                                                                            {group.evaluationWeight.reason}
                                                                        </div>
                                                                    )
                                                                )}
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <textarea
                                                                placeholder="Digite"
                                                                value={empreendimento.comentario ?? ''}
                                                                onChange={(
                                                                    event
                                                                ) =>
                                                                    this.handleComentarioChange(
                                                                        empreendimento.id,
                                                                        event.target.value
                                                                    )
                                                                }
                                                            >{empreendimento.comentario ?? ''}</textarea>
                                                        </td>

                                                        <td style={{ textAlign: 'center' }}>
                                                            {podeAvaliar && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-avaliar"
                                                                    disabled={sending}
                                                                    onClick={() =>
                                                                        this.handleAvaliar(
                                                                            empreendimento
                                                                        )
                                                                    }
                                                                >
                                                                    Avaliar
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <a
                            href={`/atualizacao-nova/${cityPeriod.id}`}
                            role="button"
                            className='btn btn-voltar'
                        >Voltar</a>
                    </div>
                </div>
            </div>
        );
    }
}

const element = document.getElementById('app-validar-empreendimentos');

if (element) {
    const props = {
        cityPeriod: JSON.parse(element.dataset.cityPeriod || '{}'),
    };

    ReactDOM.render(<ValidarEmpreendimento {...props} />, element);
}
export default ValidarEmpreendimento;